export const SIMULACAO_STATUS = {
  RUNNING: 100,
  FINISHED: 200,
}

export function isSimulacaoRunning(value) {
  return !!(value && value.status === 'running')
}

export function resolveSimulacaoStatus(httpStatus, value) {
  if (isSimulacaoRunning(value)) {
    return SIMULACAO_STATUS.RUNNING
  }
  if (httpStatus === 200) {
    return SIMULACAO_STATUS.FINISHED
  }
  return httpStatus
}
